import React from 'react';
import { Star } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export const PhotoGallery = ({ photos, onOpen }) => {
    if (!photos.length) return null;
    return (
        <div className="grid grid-cols-3 sm:grid-cols-4 gap-2" data-testid="photo-gallery">
            {photos.map((p, i) => (
                <button
                    key={p.id}
                    type="button"
                    onClick={() => onOpen(i)}
                    className="group relative aspect-square overflow-hidden rounded-sm border bg-muted"
                    title={p.filename}
                    data-testid={`photo-thumb-${p.id}`}
                >
                    <img src={`${API}${p.thumb_url}`} alt={p.filename} loading="lazy" className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" onError={(e) => { e.currentTarget.style.visibility = 'hidden'; }} />
                    {p.is_cover && (
                        <span className="absolute top-1 left-1 inline-flex items-center gap-1 text-[10px] font-semibold px-1.5 py-0.5 rounded-full bg-amber-500 text-white" data-testid={`photo-cover-badge-${p.id}`}>
                            <Star size={10} className="fill-current" /> Copertina
                        </span>
                    )}
                </button>
            ))}
        </div>
    );
};
